<template>
  <div class="course-validity-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="用户账号：" prop="user_mobile">
        <Input
          v-model="form.user_mobile"
          placeholder="请输入用户账号，即手机号码"
          clearable
          :maxlength="11"
        >
        </Input>
      </FormItem>
      <FormItem>
        <Button
          class="btn-form btn-margin-right"
          type="primary"
          size="large"
          @click="onSave"
        >
          保存
        </Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: "enrollments-edit",
  components: {},
  data() {
    return {
      showSelectCourse: false,
      courses: [],
      form: {
        user_id: "",
        user_mobile: "",
        course_id: "",
      },
      formRules: {
        real_name: [{ required: true, message: "用户账号不能为空" }],
        identity_card: [{ required: true, message: "课程不能为空" }],
      },
    };
  },

  created() {
    this.enrollmentId = this.$route.query.id;
    if (this.enrollmentId) {
      this.requestDetail();
    }
  },
  methods: {
    onSave() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        let url = `/api/course/enrollments/${this.enrollmentId}`;

        this.$http.put(url, this.form).then(() => {
          this.$Message.success("保存成功");
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        });
      });
    },
    requestDetail() {
      this.$http
        .get("/api/course/enrollments/" + this.enrollmentId)
        .then((data) => {
          this.form = data;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.course-validity-edit {
  .form {
    width: 500px;
  }
  .ivu-form-item {
    width: 620px;
    .ivu-form-item-content {
      span {
        float: right;
      }
    }
  }
  .introduction {
    width: 500px;
  }
  .btn-form {
    width: 100px;
  }
  .btn-select-student {
    position: absolute;
    top: 1px;
    left: 400px;
  }
}
</style>
